<!-- Zweck: Stellt die HTML-Struktur für shop artikel verfuegbarkeit info component im Frontend bereit. -->
@if (data && data.status.Verfuegbarkeitsinformation) {
  <div (keydown)="keydown($event)" class="infobox">
    <feature-block [features]="['Lieferantenbestellung']">
      <permission-block [oneOfRoles]="['Lieferantenbestellung']">
        @if (data.status.supplierLabel) {
          <h3>{{data.status.supplierLabel}}</h3>
        }
      </permission-block>
    </feature-block>
    @if (data.status.Nachfolgeartikel) {
      <h1>Nachfolge Artikel vorhanden!</h1>
      <hr>
        <h3>
          {{data.status.Nachfolgeartikel.ArtikelName}} <article-dtp-icon [isDtp]="data.status.Nachfolgeartikel.IstDtpArtikel"></article-dtp-icon>
        </h3>
        <h5>Nachfolger für:
          @if (data.artikel.ArtikelBezeichnung) {
            {{data.artikel.ArtikelBezeichnung}}
          }
          @if (!data.artikel.ArtikelBezeichnung) {
            {{data.artikel.ArtikelName}}
          }
          <article-dtp-icon [isDtp]="data.artikel.IstDtpArtikel"></article-dtp-icon>
        </h5>
        <div style="text-align: center">
          <table style="margin: auto">
            <tr>
              <th>EP:</th>
              <td>{{data.status.Nachfolgeartikel.Kundeneinkaufspreis}} &euro;</td>
              <td></td>
              <th>VP:</th>
              <td>{{data.status.Nachfolgeartikel.Kundenverkaufspreis}} &euro;</td>
            </tr>
          </table>
        </div>
      }
      @if (!data.status.Nachfolgeartikel) {
        <h3>
          @if (data.artikel.ArtikelBezeichnung) {
            {{data.artikel.ArtikelBezeichnung}}
          }
          @if (!data.artikel.ArtikelBezeichnung) {
            {{data.artikel.ArtikelName}}
          }
          <article-dtp-icon [isDtp]="data.artikel.IstDtpArtikel"></article-dtp-icon>
        </h3>
      }
      @for (i of data.status.Verfuegbarkeitsinformation; track i) {
        <div>
          <div style="text-align: center; padding: 10px">
            @if (i.color=='green') {
              <svg-icon [size]="100" class="infoicon infoicon-green">success-bk</svg-icon>
            }
            @if (i.color=='orange') {
              <svg-icon [size]="100" class="infoicon infoicon-orange">rueckstaende</svg-icon>
            }
            @if (i.color=='orange2') {
              <svg-icon [size]="100" class="infoicon infoicon-orange2">success-bk</svg-icon>
            }
            @if (i.color=='red') {
              <svg-icon [size]="100" class="infoicon infoicon-red">abbrechen</svg-icon>
            }
          </div>
          <div style="text-align: center; font-size: 40px">
            {{i.Menge}} ST - {{i.InfoText}}
          </div>
          @if (i.Zusatzinformation && i.Zusatzinformation.length > 0) {
            <div>
              <hr>
                <table>
                  <tr>
                    <td class="label label2">Details:</td>
                    <td class="info info2" colspan="2">
                      @for (txt of i.Zusatzinformation; track txt) {
                        <div>
                          {{txt.text}}
                        </div>
                      }
                    </td>
                  </tr>
                </table>
              </div>
            }
          </div>
        }
      </div>
    }
